/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { QuotingStrategyType } from "./QuotingStrategyType";
import {
  QuotingStrategyTypeFromJSON,
  QuotingStrategyTypeFromJSONTyped,
  QuotingStrategyTypeToJSON,
  QuotingStrategyTypeToJSONTyped,
} from "./QuotingStrategyType";
import type { QuotingActivationStrategyType } from "./QuotingActivationStrategyType";
import {
  QuotingActivationStrategyTypeFromJSON,
  QuotingActivationStrategyTypeFromJSONTyped,
  QuotingActivationStrategyTypeToJSON,
  QuotingActivationStrategyTypeToJSONTyped,
} from "./QuotingActivationStrategyType";

/**
 *
 * @export
 * @interface QuotingStrategy
 */
export interface QuotingStrategy {
  /**
   *
   * @type {QuotingStrategyType}
   * @memberof QuotingStrategy
   */
  strategyType: QuotingStrategyType;
  /**
   *
   * @type {QuotingActivationStrategyType}
   * @memberof QuotingStrategy
   */
  activationStrategyType: QuotingActivationStrategyType;
}

/**
 * Check if a given object implements the QuotingStrategy interface.
 */
export function instanceOfQuotingStrategy(
  value: object,
): value is QuotingStrategy {
  if (!("strategyType" in value) || value["strategyType"] === undefined)
    return false;
  if (
    !("activationStrategyType" in value) ||
    value["activationStrategyType"] === undefined
  )
    return false;
  return true;
}

export function QuotingStrategyFromJSON(json: any): QuotingStrategy {
  return QuotingStrategyFromJSONTyped(json, false);
}

export function QuotingStrategyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuotingStrategy {
  if (json == null) {
    return json;
  }
  return {
    strategyType: QuotingStrategyTypeFromJSON(json["strategyType"]),
    activationStrategyType: QuotingActivationStrategyTypeFromJSON(
      json["activationStrategyType"],
    ),
  };
}

export function QuotingStrategyToJSON(json: any): QuotingStrategy {
  return QuotingStrategyToJSONTyped(json, false);
}

export function QuotingStrategyToJSONTyped(
  value?: QuotingStrategy | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    strategyType: QuotingStrategyTypeToJSON(value["strategyType"]),
    activationStrategyType: QuotingActivationStrategyTypeToJSON(
      value["activationStrategyType"],
    ),
  };
}
